import { useQuery } from '@tanstack/react-query';
import { getClientChamps } from '../api/CLIENTS/clients';

/**
 * Fetches the custom fields (champs personnalisés) attached to a client.
 * Pass { enabled: false } to delay the fetch until needed (e.g. when a modal opens).
 */
export const useClientChamps = (clientId, options = {}) => {
  return useQuery({
    queryKey: ['clientChamps', clientId],
    queryFn:  () => getClientChamps(clientId),
    enabled:  !!clientId && options.enabled !== false,
    staleTime: 5 * 60 * 1000,
  });
};
